import MapScanCount from './mapScanCount.container';

export default MapScanCount;
